{
  "labels": {
    "family": "Familiengeschichte",
    "events": "Skatturniere",
    "gallery": "Galerie",
    "locations": "Veranstaltungsorte",
    "familyTree": "Stammbaum",
    "familyMember": "Familienmitglieder",
    "tree": "Stammbaum",
    "calendar": "Kalender",
    "table": "Mitgliederliste",
    "map": "Wohnorte",
    "userProfile": "Nutzerprofil",
    "statistics": "Statistiken",
    "imprint": "Impressum",
    "security": "Datenschutz",
    "ottoMeissner": "Otto Meissner",
    "niederstaucha": "Niederstaucha",
    "leipzig": "Leipzig"
  },
  "options": {
    "einfach": "Einfach",
    "schneider": "Schneider",
    "schwarz": "Schwarz",
    "hand": "Hand",
    "handSchneider": "Hand Schneider",
    "handSchwarz": "Hand Schwarz",
    "handSchneiderAngesagt": "Hand Schneider angesagt",
    "handSchneiderAngesagtSchwarz": "Hand Schneider angesagt Schwarz",
    "handSchwarzAngesagt": "Hand Schwarz angesagt",
    "handOuvert": "Hand Ouvert",
    "ouvert": "Ouvert"
  }
}
